import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Home, User, Calendar, Loader2, Bot, Star } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';
import { getProspects } from '../lib/inspectionService';
import { useAuth } from "../AuthContext";
import { useParams } from 'react-router-dom';

import './ProspectList.css';

const ProspectList = () => {
    // Sample data - replace with your backend data
    const [chats, setChats] = useState([]);
    const [loading, setLoading] = useState(true);
    const { userId } = useAuth();
    const { propertyId } = useParams();
    const [expandedCard, setExpandedCard] = useState(null);

    // Toggle collapse state for a specific chat
    const toggleCollapse = (id) => {
        setExpandedCard(expandedCard === id ? null : id);
    };

    useEffect(() => {
        fetchProspects();
    }, []);

    const fetchProspects = async () => {
        try {
            // Simulate API call with setTimeout
            const data = await getProspects(propertyId);

            // Example data - replace this with your actual API call
            setChats(data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching properties:', error);
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="flex justify-center items-center min-h-[200px]">
                <Loader2 className="h-8 w-8 animate-spin text-blue-500" />
            </div>
        );
    }

    const getCardContent = (chat) => {
        if (chat.status !== 2) {
            return (
                <div className="grid gap-4">
                    SMS sent, no response yet
                </div>
            );
        } else {
            const chatHistory = chat.history.split('\r\n').map((message) => {
                return <div>
                    <span>{message.role}</span>
                    <span>{message.content}</span>
                </div>;
            });

            return (
                <div>
                    <div className="grid gap-4">
                        <span>{chat.summary}</span>
                    </div>
                    <div className='chat-history-toggle'>
                        <a href={`/prospect/${chat.uid}`} className="text-blue-500 hover:underline"> View Details</a>
                        {/* <button
                            onClick={() => toggleCollapse(chat.uid)}
                            className="text-blue-500 hover:underline"
                        >
                            {expandedCard === chat.uid ? 'Hide' : 'Show'} History
                        </button> */}
                    </div>
                    {expandedCard === chat.uid && (
                        <div className="mt-4 space-y-2">
                            {JSON.parse(chat.history).map((message, index) => (
                                <div key={index} className="p-2 bg-gray-100 rounded flex items-center">
                                    <span>{message.role !== 'user' ? <Bot className="mr-2" color="red"/> : <User className="mr-2" color="#334433" />}</span>
                                    <span>{message.content}</span>
                                </div>
                            ))}
                            <div className='chat-history-toggle'>
                                <button
                                    onClick={() => toggleCollapse(chat.uid)}
                                    className="text-blue-500 hover:underline"
                                >
                                    {expandedCard === chat.uid ? 'Hide' : 'Show'} History
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            );
        }

    };

    return (
        <div className="container mx-auto px-6 py-8">
            <div className="flex justify-between items-center mb-8">
                <h1 className="text-2xl font-bold">Prospects</h1>
                <Link
                    to={`/properties/${propertyId}/prospects/new`}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 hover:bg-blue-700"
                >
                    <Plus className="w-4 h-4" />
                    Create Prospect
                </Link>
            </div>

            <div className="grid gap-6">
                {chats.map((chat) => (

                    <Card className="hover:shadow-lg transition-shadow">
                        <CardHeader className='card-header'>
                            <CardTitle className="flex justify-between items-start">
                                <span>{chat.Prospect.name}<a className='phone' href={`tel:${chat.Prospect.phone}`}>{chat.Prospect.phone}</a></span>
                                {chat.score && <div className="flex items-center gap-2">
                                    <Star className="w-4 h-4" color='red'/>
                                    <span>{chat.score}/10</span>
                                </div>}

                            </CardTitle>
                        </CardHeader>
                        <CardContent>
                            {getCardContent(chat)}
                        </CardContent>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default ProspectList;